import { render, staticRenderFns } from "./assignAuditPermissionDialog.vue?vue&type=template&id=5207b11a&scoped=true&"
import script from "./assignAuditPermissionDialog.vue?vue&type=script&lang=js&"
export * from "./assignAuditPermissionDialog.vue?vue&type=script&lang=js&"
import style0 from "./assignAuditPermissionDialog.vue?vue&type=style&index=0&id=5207b11a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207b11a",
  null
  
)

export default component.exports